webpackJsonp([37721738025407],{

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/K1.34354a7a.jpg";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/K2.256f31d4.jpg";

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/K3.d5f54cef.jpg";

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/M1.3d64255e.jpg";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/M2.99aaf64e.jpg";

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/M3.e9ccf9c3.jpg";

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/treneri.4ecec2b8.jpg";

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Image = function (_React$Component) {
	  _inherits(Image, _React$Component);
	
	  function Image() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Image);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      loaded: true
	    }, _this.onLoad = function () {
	      _this.setState({ loaded: true });
	    }, _this.setImage = function (el) {
	      _this.image = el;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Image.prototype.componentDidMount = function componentDidMount() {
	    if (!this.image.complete) this.setState({ loaded: false });
	  };
	
	  Image.prototype.render = function render() {
	    var style = { opacity: this.state.loaded ? '' : 0 };
	
	    return _react2.default.createElement('img', _extends({}, this.props, { style: style, onLoad: this.onLoad, ref: this.setImage }));
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	exports.default = Image;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(57);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Image = __webpack_require__(79);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _treneri = __webpack_require__(469);
	
	var _treneri2 = _interopRequireDefault(_treneri);
	
	var _K = __webpack_require__(460);
	
	var _K2 = _interopRequireDefault(_K);
	
	var _K3 = __webpack_require__(461);
	
	var _K4 = _interopRequireDefault(_K3);
	
	var _K5 = __webpack_require__(462);
	
	var _K6 = _interopRequireDefault(_K5);
	
	var _M = __webpack_require__(463);
	
	var _M2 = _interopRequireDefault(_M);
	
	var _M3 = __webpack_require__(464);
	
	var _M4 = _interopRequireDefault(_M3);
	
	var _M5 = __webpack_require__(465);
	
	var _M6 = _interopRequireDefault(_M5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Treneri = function Treneri() {
	  return _react2.default.createElement(
	    'article',
	    { className: 'Trainers' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Muvko - Tren\xE9\u0159i' }),
	    _react2.default.createElement(_Image2.default, { src: _treneri2.default, alt: 'Muvko tren\xE9\u0159i' }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        'Honza'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        'Katka'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        'Michal'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Ka\u017Ed\xFD z n\xE1s m\xE1 sv\u016Fj styl, ka\u017Ed\xFD V\xE1m d\xE1v\xE1me do t\u011Bla malinko jinak, ale l\xE1sku k pohybu m\xE1me spole\u010Dnou a na ka\u017Ed\xE9m tr\xE9ninku se pro V\xE1s sna\u017E\xEDme ze sebe vydat to nejlep\u0161\xED.'
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Katka'
	      ),
	      _react2.default.createElement(_Image2.default, { src: _K2.default, alt: 'Ka\u010Dka v bl\xE1t\u011B na Spartan Race' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Sport doprov\xE1z\xED cel\xFD m\u016Fj \u017Eivot. V d\u011Btstv\xED jsem si pro\u0161la z\xE1vodn\xEDm plav\xE1n\xEDm, atletikou a modern\xEDm tancov\xE1n\xEDm. Pr\xE1v\u011B tanec tvo\u0159il nejdel\u0161\xED a nejd\u016Fle\u017Eit\u011Bj\u0161\xED \u010D\xE1st m\xE9ho sportovn\xEDho \u017Eivota a dal mi tu nejlep\u0161\xED pohybovou pr\u016Fpravu. D\xEDky tancov\xE1n\xED jsem z\xEDskala fyzickou vytrvalost, v\xFDbu\u0161nost, flexibilitu, ohebnost. Tvrd\xE9 tr\xE9ninky 3x t\xFDdn\u011B, z\xE1vody ka\u017Ed\xFD v\xEDkend, pr\xE1zdniny traven\xE9 na soust\u0159ed\u011Bn\xEDch. Tato chu\u0165 d\u0159\xEDt, c\xEDtit pot v o\u010D\xEDch a bolest v nohou mi z\u016Fstala. Bolest miluju :).'
	      ),
	      _react2.default.createElement(_Image2.default, { src: _K4.default, alt: 'Ka\u010Dka na Muvko kempu' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'S kolegou a dobr\xFDm kamar\xE1dem Michalem jsme se v roce 2014 rozhodli, \u017Ee spole\u010Dnou l\xE1sku k pohybu a p\u0159ebyte\u010Dnou energii bychom r\xE1di p\u0159ed\xE1vali d\xE1l. MUVKO jsme zalo\u017Eili jako otev\u0159en\xE9 tr\xE9ninky opravdu pro ka\u017Ed\xE9ho, kdo si chce p\u0159ij\xEDt d\xE1t do t\u011Bla a neboj\xED se d\u0159iny. Ka\u017Ed\xFD \u010Dlov\u011Bk, kter\xFD mi na tr\xE9nink p\u0159ijde, je pro m\u011B vz\xE1cnost a sna\u017E\xEDm se mu z m\xFDch zku\u0161enost\xED a energie p\u0159edat co nejv\xEDc, aby t\u011Blo i du\u0161e byly po tr\xE9ninku spokojen\xE9.'
	      ),
	      _react2.default.createElement(_Image2.default, { src: _K6.default, alt: 'Ka\u010Dka v Energymu' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Za ty 4 roky se n\xE1m poda\u0159ilo d\xE1t dohromady slu\u0161nou z\xE1kladnu lid\xED, kte\u0159\xED se k n\xE1m r\xE1di vrac\xED, jezd\xED s n\xE1mi na sportovn\xED kempy a dobrovoln\u011B s n\xE1mi d\u011Blaj\xED i jin\xE9 aktivity. Ob\u010Das si \u0159\xEDk\xE1me muvko rodina, co\u017E je n\u011Bco, co m\u011B na MUVKU fakt bav\xED a v\xE1\u017E\xEDm si to.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Vedle fitness dnes miluju b\u011Bh a zal\xEDben\xED jsem na\u0161la v \u010D\xEDm d\xE1l t\xEDm v\xEDc popul\xE1rn\u011Bj\u0161\xEDch extr\xE9mn\xEDch p\u0159ek\xE1\u017Ekov\xFDch z\xE1vodech. R\xE1da b\u011Bh\xE1m po kopc\xEDch, \u0161plh\xE1m po lan\u011B, nos\xEDm t\u011B\u017Ek\xE9 pytle a \u010D\xEDm d\xE9le to trv\xE1, t\xEDm l\xEDp :). Nen\xED proto divu, \u017Ee moje tr\xE9ninky jsou v\xEDc ne\u017E o s\xEDle o fyzick\xE9 vytrvalosti a dynamice. Pokud nem\xE1te r\xE1di cardio, asi V\xE1s moje tr\xE9ninky slu\u0161n\u011B potr\xE1p\xED. Moje heslo: cardio is hardio :).'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'small' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'B\u011Bh v \u010D\xEDslech:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            '5 km: 21:05'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '10 km: 42:20'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'P\u016Flmaraton: 1:38:50'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Maraton: 3:50:15'
	          )
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          'N\u011Bkter\xE9 p\u0159ek\xE1\u017Ekov\xE9 z\xE1vody:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Army Run 2015: 3. m\xEDsto kategorie army \u017Eeny'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Spartan Race Super 2016: 2.m\xEDsto m\xEDsto open kategorie \u017Eeny'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Spartan Race Beast 2016:  2. m\xEDsto open kategorie \u017Eeny'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Spartan Race Super 2017: 2. m\xEDsto open kategorie \u017Eeny '
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Spartan Race Ultra Beast 2017: 8. m\xEDsto kategorie elita \u017Eeny'
	          )
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Sky up z\xE1vody:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Beskydsk\xE1 sedmi\u010Dka 2016'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Krkono\u0161sk\xE1 pades\xE1tka 2017: 2. m\xEDsto kategorie p\xE1ry mix'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Redbull 400 2017: 8. m\xEDsto kategorie \u017Eeny A'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h6',
	        null,
	        'Vzd\u011Bl\xE1n\xED:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'small em' },
	        _react2.default.createElement(
	          'li',
	          null,
	          'Magistersk\xE9 studium na pr\xE1vnick\xE9 fakult\u011B Univerzity Karlovy v Praze'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Instruktor fitness a Instruktor kondi\u010Dn\xEDho posilov\xE1n\xED - Tren\xE9rsk\xE1 \u0161kola Ikaros'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Michal'
	      ),
	      _react2.default.createElement(_Image2.default, { src: _M2.default, alt: 'Ka\u010Dka v bl\xE1t\u011B na Spartan Race' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I j\xE1 jsem sportoval od mala. Hr\xE1l jsem tenis, fotbal a z\xE1vodn\u011B hokej, kter\xE9mu jsem se v\u011Bnoval p\u0159es 12 let. Pozd\u011Bji jsem p\u0159esedlal na florbal, kdy jsem dv\u011B sez\xF3ny obl\xE9kal i extraligov\xFD dres. Celkov\u011B m\u011B to ale t\xE1hlo k v\xEDce silov\u011Bj\u0161\xEDm sport\u016Fm. Neust\xE1le jsem byl v kontaktu s fitness a m\xFDm snem bylo v tomto odv\u011Btv\xED n\u011Bco tvo\u0159it. MUVKO byla tedy ide\xE1ln\xED p\u0159\xEDle\u017Eitost.'
	      ),
	      _react2.default.createElement(_Image2.default, { src: _M4.default, alt: 'Ka\u010Dka v bl\xE1t\u011B na Spartan Race' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Na\u0161e tr\xE9ninky m\u011B hodn\u011B nab\xEDj\xED a bav\xED. Bav\xED m\u011B tvo\u0159it n\xE1pl\u0148 tr\xE9ninku, sledovat lidi kdy\u017E d\u0159ou, bav\xED m\u011B pob\xEDhat na flooru a hecovat v\u0161echny k je\u0161t\u011B v\u011Bt\u0161\xEDm v\xFDkon\u016Fm. Stra\u0161n\u011B r\xE1d m\xE1m taky atmosf\xE9ru v s\xE1le, kter\xE1 je pln\xE1 energie a dobr\xE9 n\xE1lady. Postupn\u011B se MUVKO stalo m\xEDstem, kde vznikaj\xED nov\xE1 p\u0159\xE1telstv\xED a lidi si p\u0159ijdou nejen s\xE1hnout na dno sv\xFDch moment\xE1ln\xEDch sil, ale taky pokecat a zasm\xE1t se (OK, u toho stre\u010Dinku byste ale zas tak kecat nemuseli ;-)). S trochou nads\xE1zky jsme takov\xE1 rodinka, jezd\xEDme spolu na campy, po\u0159\xE1d\xE1me spole\u010Dn\u011B i n\u011Bjakou tu p\xE1rty anebo vyjedeme za Prahu na p\u0159ek\xE1\u017Ekov\xFD z\xE1vod. L\xEDb\xED se mi ta soudru\u017Enost.'
	      ),
	      _react2.default.createElement(_Image2.default, { src: _M6.default, alt: 'Ka\u010Dka v bl\xE1t\u011B na Spartan Race' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Cht\u011Bli bychom pokra\u010Dovat d\xE1l v tom, co d\u011Bl\xE1me a neust\xE1le p\u0159ich\xE1zet s n\u011B\u010D\xEDm nov\xFDm a v\xEDce zapojit lidi do d\u011Bn\xED okolo, nezab\u0159ednout do stereotypu. Hlavn\xED je pro n\xE1s p\u0159edev\u0161\xEDm rozd\xE1vat radost :).'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'KEEP MUUUVIN\xB4'
	      ),
	      _react2.default.createElement(
	        'h6',
	        null,
	        'Vzd\u011Bl\xE1n\xED:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'small em' },
	        _react2.default.createElement(
	          'li',
	          null,
	          'Magistersk\xE9 studim na Ostravsk\xE9 univerzit\u011B obor t\u011Blov\xFDchova a matematika pro st\u0159edn\xED \u0161koly'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Instruktor fitness, Instruktor kondi\u010Dn\xEDho posilov\xE1n\xED a Osobn\xED tren\xE9r kondi\u010Dn\xEDho posilov\xE1n\xED - Tren\xE9rsk\xE1 \u0161kola Olympia'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Treneri;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-treneri-js-9608aef944e9c8d22b9e.js